import "./Page.styl";

import React from "react";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import { Link, Miss, Redirect } from "react-router";
import Match from "../components/Match";

import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";

import All from "./All";
import Single from "./Single";

class Page extends React.Component {
  constructor() {
    super();
  }

  redirect(to) {
    const { router } = this.context;
    // so that folks can unit test w/o hassle
    if (router) router.transitionTo(to);
  }

  render() {
    const { pathname } = this.props;

    return (
      <div className="blog-page">
        <Header />

        <Match
          authorized
          exactly
          pattern={`${pathname}/:slug`}
          component={Single}
        />
        <Match
          authorized
          exactly
          pattern={`${pathname}/p/:page`}
          component={All}
        />
        <Match authorized exactly pattern={pathname} component={All} />
        <Miss render={() => <Redirect to="/404" />} />

        <Footer />
      </div>
    );
  }
}

Page.contextTypes = {
  router: React.PropTypes.object.isRequired,
};

export default connect((state) => ({}), {})(Page);



/** WEBPACK FOOTER **
 ** ./src/browser/blog/Page.js
 **/